
policyFlags.classy.controller({
    name: 'PolicyFlagsController',
    inject: ['$scope', 'PolicyModelService', 'HelpSystemModelService', 'SchoolModelService',
        'authServiceFactory', 'StandardCudFactory', '$rootScope'],
    init: function()
    {
        this.$rootScope.model = this.PolicyModelService;
        this.$.PolicyModelService = this.PolicyModelService;
        this.$.item = this.PolicyModelService.data[0];  
        this.$.HelpSystemModelService = this.HelpSystemModelService;
        this.$.threshItem = this.SchoolModelService.get()[0];
    },
   submit: function(scope, instance, form)
    {
        var parent = this;
        if (form.$valid)
        {
            instance.options.factor  = .3;
            this.PolicyModelService.put(this.id, this.$.item, instance).then(function (response) {

            });
        }
        else
        {
            instance.stop(-1);
        }
    },
    successSave: function(scope, instance, callback) 
    {
        this.PolicyModelService.set(this.PolicyModelService.data);
        if (typeof callback !== 'undefined')
            callback();
    },
    activeChange: function(field)
    {
        if (this.$.item[field+'_default']!==undefined && this.$.item[field]=="1" && (this.$.item[field+'_default']==0 || this.$.item[field+'_default']=='')) {
            this.$.item[field+'_default'] = 0;
        }
        this.$.item[field] = Number(this.$.item[field]);
    }/*,
    apply: function()
    {
        this.$rootScope.$apply();
        this.$.item = this.PolicyModelService.data[0];
    }*/
});

